import { render, staticRenderFns } from "./OzDivider.vue?vue&type=template&id=7d1a3c92&"
import script from "./OzDivider.vue?vue&type=script&lang=ts&"
export * from "./OzDivider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports